import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import LoanService from "../../../../../services/LoanService";
import ApproveModal from "../ApproveModal";

const statusVariant = {
	ACTIVE: "success",
	NOT_STARTED: "warning",
	PENDING: "info",
	COMPLETED: "secondary",
};

const CardItem = ({ item, index, setShouldUpdate, selectTab }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const [approveModal, setApproveModal] = useState(false);
	const [paying, setPaying] = useState(false);

	const handlePay = () => {
		setPaying(true);
		new LoanService()
			.pay(item.id)
			.then((res) => {
				if (res?.status === 200 || res?.status === 201) {
					toast.success(Translate[lang]?.updated_successfully);
					setShouldUpdate((prev) => !prev);
				}
			})
			.finally(() => setPaying(false));
	};

	return (
		<>
			<tr key={index} className="text-center">
				<td>
					<strong>{item?.employee?.id || item?.id}</strong>
				</td>
				<td>{item?.employee?.name || "-"}</td>
				<td>{item?.employee?.department?.name || "-"}</td>
				<td>{item?.loanAmount ?? "-"}</td>
				<td style={{ textTransform: "capitalize" }}>
					{item?.type?.replaceAll("_", " ").toLocaleLowerCase() || "-"}
				</td>
				<td>{item?.numberOfInstallments ?? "-"}</td>
				<td>{item?.numberOfPaymentsMade ?? "-"}</td>
				<td>{item?.remainingInstallments ?? "-"}</td>
				<td>{item?.installmentAmount ?? "-"}</td>
				<td>{item?.paymentStartDate?.split("T")[0] || "-"}</td>
				<td>{item?.note || "-"}</td>
				<td style={{ textTransform: "capitalize" }}>
					<Badge variant={statusVariant[item?.status] || "secondary"}>
						{item?.status?.replaceAll("_", " ")?.toLocaleLowerCase() || "-"}
					</Badge>
				</td>
				<td>
					{selectTab === "not_started" && (
						<button
							className="btn btn-sm btn-primary"
							onClick={() => setApproveModal(true)}>
							{Translate[lang]?.approve}
						</button>
					)}
					{selectTab === "has_loans" && (
						<button
							className="btn btn-sm btn-primary"
							disabled={paying}
							onClick={handlePay}>
							{paying ? (
								<span className="spinner-border spinner-border-sm" />
							) : (
								Translate[lang]?.pay
							)}
						</button>
					)}
				</td>
			</tr>
			{approveModal && (
				<ApproveModal
					modal={approveModal}
					setModal={() => setApproveModal(false)}
					item={item}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</>
	);
};

export default CardItem;
